<template>
  <restore-component></restore-component>
</template>

<script>
import restoreComponent from "../components/registration/restoreComponent";
export default {
  name: "restore",
  components: { restoreComponent },
};
</script>

<style scoped></style>
